import type { Coverage, GridDomain } from '@opengeoweb/shared/src/lib/types';
import type { FlySafeRow } from './types';

export function coverageToRowsGrid(
  cov?: Coverage<GridDomain>,
): FlySafeRow[] | null {
  if (!cov) {
    return null;
  }

  const { axes } = cov.domain;
  const { ranges } = cov;

  const tVals = axes.t?.values as string[];
  const zVals = axes.z.values as number[];

  const yCount = axes.y.values.length;
  const xCount = axes.x.values.length;

  const dens = ranges.dens?.values as number[];
  const ff = ranges.ff?.values as number[];
  const dd = ranges.dd?.values as number[];

  if (!tVals?.length || !zVals?.length) {
    return null;
  }
  if (!dens?.length || !ff?.length || !dd?.length) {
    return null;
  }

  const tCount = tVals.length;
  const zCount = zVals.length;

  const out: FlySafeRow[] = [];
  out.length = tCount * zCount * yCount * xCount;

  let ki = -1;

  for (let ti = 0; ti < tCount; ti += 1) {
    for (let zi = 0; zi < zCount; zi += 1) {
      for (let yi = 0; yi < yCount; yi += 1) {
        for (let xi = 0; xi < xCount; xi += 1) {
          const idx = ((ti * zCount + zi) * yCount + yi) * xCount + xi;

          out[(ki += 1)] = {
            datetime: new Date(tVals[ti]),
            height: zVals[zi],
            dens: dens[idx] ?? null,
            ff: ff[idx] ?? null,
            dd: dd[idx] ?? null,
          };
        }
      }
    }
  }

  return out;
}
